const UIFieldTypes = {
    Text_Single: {
        value: '1',
        label: 'Text field',
        translationKey: "textField"
    },
    Text_Multi_Line: {
        value: '2',
        label: 'Multi-line text field',
        translationKey: "multiLineTextField"
    },
    Select_Single: {
        value: '3',
        label: 'Radio Buttons',
        translationKey: "radioButtons"
    },
    Select_Multi: {//add
        value: '4',
        label: 'Check Boxes',
        translationKey: "checkBoxes"
    },
    Text_Multi_Line_Adv: {
        value: '5',
        label: 'Text Area (with character count)',
        translationKey: "textAreaWithCharacterCount"
    },
    Select_Event: {//add
        value: '6',
        label: 'Select Event',
        settingDataRelationshipName: 'eventType',
        settingDataColumnKey: 'eventTypeId',
        translationKey: "selectEvent"
    },
    Select_Reader: {//add
        value: '7',
        label: 'Select Reader',
        settingDataRelationshipName: 'deviceImprox',
        settingDataColumnKey: 'deviceImproxId',
        translationKey: "selectReader"
    },
    Select_Zone: {//add
        value: '8',
        label: 'Select Zone',
        settingDataRelationshipName: 'zone',
        settingDataColumnKey: 'zoneId',
        translationKey: "selectZone"
    },
    Select_Message: { //add
        value: '9',
        label: 'Select Message',
        settingDataRelationshipName: 'longMessage',
        settingDataColumnKey: 'longMessageId',
        translationKey: "selectMessage"
    },
    Image: {
        value: '10',
        label: 'Image',
        translationKey: "image"
    },
    Select_DTP: {
        value: '11',
        label: 'Select Device Time Pattern',
        settingDataColumnKey: 'timePatternId',
        settingDataRelationshipName: 'timePattern',
        translationKey: "selectDeviceTimePattern"
    },
    Select_Multiple_DTPs: {
        value: '12',
        label: 'Select Multiple Device Time Patterns',
        settingDataColumnKey: 'timePatternId',
        settingDataRelationshipName: 'timePattern',
        translationKey: "selectMultipleDeviceTimePatterns"
    },
    Select_Profile: {
        value: '25',
        label: 'Select Profile',
        settingDataRelationshipName: 'profile',
        settingDataColumnKey: 'profileId',
        translationKey: "selectProfile"
    },
    Select_Custom: { //add
        value: '26',
        label: 'Select Custom',
        translationKey: "selectCustom"
    },
    Select_Department: {
        value: '27',
        label: 'Select Department',
        settingDataRelationshipName: 'department',
        settingDataColumnKey: 'departmentId',
        translationKey: "selectDepartment"
    },
    Select_Company: {
        value: '28',
        label: 'Select Company',
        settingDataRelationshipName: 'company',
        settingDataColumnKey: 'companyId',
        translationKey: "selectCompany"
    },
    Select_Date: { //add
        value: '29',
        label: 'Select Date',
        translationKey: "selectDate"
    },
    Select_Date_Time: {
        value: '30',
        label: 'Select Date/Time',
        translationKey: "selectDateTime"
    },
    Select_Email_Address: {//add
        value: '31',
        label: 'Select Email Address',
        settingDataRelationshipName: 'masterDetail',
        settingDataColumnKey: 'masterDetailId',
        translationKey: "selectEmailAddress"
    },
    Select_Contact_Number: {
        value: '32',
        label: 'Contact Number',
        settingDataRelationshipName: 'masterDetail',
        settingDataColumnKey: 'masterDetailId',
        translationKey: "contactNumber"
    },
    Select_Date_Range: {
        value: '41',
        label: 'Select Date Range',
        translationKey: "selectDateRange"
    },
    Select_Category: {
        value: '42',
        label: 'Select Category',
        settingDataRelationshipName: 'profile',
        settingDataColumnKey: 'profileId',
        translationKey: "selectCategory"
    },
    Select_Master: {
        value: '49',
        label: 'Select Master',
        settingDataRelationshipName: 'master',
        settingDataColumnKey: 'masterId',
        translationKey: "selectMaster"
    },
    Select_Custom_Multi: {//add
        value: '52',
        label: 'Select Custom Multi',
        translationKey: "selectCustomMulti"
    },
    Select_Master_Type: {
        value: '53',
        label: 'Select Master Type',
        settingDataColumnKey: 'masterTypeId',
        translationKey: "selectMasterType"
    },
    Select_Provided: {//add
        value: '55',
        label: 'Select Provided',
        settingDataColumnKey: 'providedId',
        translationKey: "selectProvided"
    },
    Select_Access_Group: {
        value: '56',
        label: 'Select Access Group',
        settingDataColumnKey: 'accessGroupId',
        settingDataRelationshipName: 'accessGroup',
        translationKey: "selectAccessGroup"
    },
    Toggle_Field: {
        value: '72',
        label: '',
        translationKey: ""
    },
    Select_Multiple_Readers: {
        value: '13',
        label: 'Select Multiple Readers',
        settingDataColumnKey: 'deviceImproxId',
        settingDataRelationshipName: 'deviceImprox',
        translationKey: "selectMultipleReaders"
    },
    Select_AuditType: {
        value: '46',
        label: 'Select Audit Type',
        settingDataRelationshipName: 'auditType',
        settingDataColumnKey: 'auditTypeId',
        translationKey: "selectAuditType"
    },
    Select_AuditSubType: {
        value: '47',
        label: 'Select Audit Sub Type',
        settingDataRelationshipName: 'auditSubType',
        settingDataColumnKey: 'auditSubTypeId',
        translationKey: "selectAuditSubType"
    },
    Select_AuditActionType: {
        value: '45',
        label: 'Select Audit Action Type',
        settingDataRelationshipName: 'auditActionType',
        settingDataColumnKey: 'auditActionTypeId',
        translationKey: "selectAuditActionType"
    },
};

export default UIFieldTypes;

/**
 * Useful because multi select field need to be handle differently in UI compared to other field types,
 * multi select should be shown as a table.
 *
 * @param fieldTypeId field id refer to UI_TYPE table in database
 * @returns boolean  true if field type is multi select field otherwise false
 */
export const isMultiSelectField = (fieldTypeId: string): boolean => {
    return fieldTypeId === UIFieldTypes.Select_Multiple_DTPs.value || fieldTypeId === UIFieldTypes.Select_Multiple_Readers.value;
}

export const findSettingDataColumnKey = (fieldTypeId) => {
    const uiFieldType: any = Object.values(UIFieldTypes).find((uiFieldType) => { return fieldTypeId === uiFieldType.value });
    return uiFieldType?.settingDataColumnKey ?? ''
};
